import { Section } from '../layout/Section';
import { Pill } from '../ui/Pill';
import { Picture } from '../ui/Picture';
import { EmailCapture } from '../ui/EmailCapture';
import { Reveal } from '../ui/Reveal';
import { submitDemoRequest } from '../../lib/forms';
import { requestDemo } from '../../data/landing';
import styles from './RequestDemo.module.css';

/** Rendered by Layout on every page, so no page imports it directly. */
export function RequestDemo() {
  return (
    <Section id="demo">
      <Reveal className={styles.grid} variant="scale">
        <div className={styles.copy}>
          <Pill tone="muted">{requestDemo.eyebrow}</Pill>
          <h2 className={`${styles.title} u-h2`}>{requestDemo.title}</h2>
          <EmailCapture
            onSubmit={submitDemoRequest}
            placeholder={requestDemo.placeholder}
            cta={requestDemo.cta}
            label="Work email address"
          />
        </div>

        <Picture
          name={requestDemo.image}
          alt="A valet returning car keys to a guest outside a hotel entrance"
          sizes="(max-width: 1023px) 100vw, 45vw"
          className={styles.media}
        />
      </Reveal>
    </Section>
  );
}
